window.maskInputDate = function (input) {
    let regExpMask = IMask(
        input, {
            mask: '00.00.0000'
        });
}

if (document.querySelector(".input--data")) {
    let inputDate = document.querySelectorAll(".input--data");
    for (let i = 0; i < inputDate.length; i++) {
        maskInputDate(inputDate[i]);
    }
}


let number_format = function (number, decimals, dec_point, thousands_sep) {

    if (typeof (number) == "string") {
        number = parseFloat(number);
    }
    ;

    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += '';
    let x = nstr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? dec_point + x[1] : '';
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');

    return x1 + x2;
}

function changePrice(price) {
    if (price || price == 0) {
        return number_format(price, 0, ',', ' ')
    }
}


function countPrice() {
    if (document.getElementById("price-pln")) {
        let pricePln = document.getElementById("price-pln");
        let priceUsd = 0;

        if (document.getElementById("price-usd")) {
            priceUsd = document.getElementById("price-usd");
        }
        let counter = document.querySelectorAll(".register__h").length;

        let pricePlnVal = parseFloat(pricePln.getAttribute("data-price").replace(" ", ""));
        let priceUsdVal = 0;
        if (document.getElementById("price-usd")) {
            priceUsdVal = parseFloat(priceUsd.getAttribute("data-price").replace(" ", ""));
        }
        pricePlnVal = pricePlnVal * counter;
        priceUsdVal = priceUsdVal * counter;

        if (document.querySelector(".facultative-trips-box")) {
            let inputsFacultativeChecked = document.querySelectorAll(".facultative-trips-box input:checked");

            for (let i = 0; i < inputsFacultativeChecked.length; i++) {
                if (inputsFacultativeChecked[i].getAttribute("data-waluta") == "PLN") {
                    pricePlnVal += parseFloat(inputsFacultativeChecked[i].getAttribute("data-cena").replace(" ", ""));
                } else {
                    priceUsdVal += parseFloat(inputsFacultativeChecked[i].getAttribute("data-cena").replace(" ", ""));
                }
            }
        }

        pricePln.innerText = changePrice(pricePlnVal);
        if (document.getElementById("price-usd")) {
            priceUsd.innerText = changePrice(priceUsdVal);
        }

        if (document.getElementById("ubezpieczenie")) {
            let ubezpieczenie = document.getElementById("ubezpieczenie");
            let ubezpieczenieKwota = 0;

            let accordion__contentList = document.querySelectorAll(".accordion__content");
            console.log(accordion__contentList);
            for (let i = 0; i < accordion__contentList.length; i++) {
                insuranceResignationValue = accordion__contentList[i].querySelector(".insurance-resignation input:checked").value;
                if (insuranceResignationValue == "1") {
                    let insuranceInputs = accordion__contentList[i].querySelectorAll("input[data-ubezpieczenie]:checked");
                    for (let j = 0; j < insuranceInputs.length; j++) {
                        let priceItem = insuranceInputs[j].getAttribute("data-ubezpieczenie");
                        ubezpieczenieKwota += priceItem;
                        if (insuranceInputs[j].hasAttribute("data-ubezpieczenie2")) {
                            let priceItem2 = insuranceInputs[j].getAttribute("data-ubezpieczenie2");
                            ubezpieczenieKwota += priceItem2;
                        }
                    }
                }
            }
            let ubezpieczeniaPodstawowe = document.querySelectorAll("input[data-ubezpieczenie-v1]:checked");
            for (let i = 0; i < ubezpieczeniaPodstawowe.length; i++) {
                let priceItem3 = ubezpieczeniaPodstawowe[i].getAttribute("data-ubezpieczenie-v1");
                ubezpieczenieKwota += priceItem3;
            }

            ubezpieczenie.innerText(changePrice(ubezpieczenieKwota));

        }
    }
}


if (document.querySelectorAll(".facultative-trips input")) {
    let inputsFacultative = document.querySelectorAll(".facultative-trips input");
    for (let i = 0; i < inputsFacultative.length; i++) {
        inputsFacultative[i].addEventListener("change", countPrice);
    }
}
// if (document.querySelectorAll(".insurance-resignation input")) {
//     let inputsFacultative = document.querySelectorAll(".insurance-resignation input");
//     for (let i = 0; i < inputsFacultative.length; i++) {
//         inputsFacultative[i].addEventListener("change", countPrice);
//     }
// }


function noEmail(noemail) {
    let email = noemail.closest(".register__fieldset").querySelector("input[type='email']");
    let wrapperEmail = email.closest(".form__input");
    let label = wrapperEmail.querySelector("label");
    noemail.addEventListener("click", function () {
        if (noemail.checked) {
            email.removeAttribute("required");
            let labelVal = (label.innerHTML).replace("*", "");
            label.innerHTML = labelVal;
            email.setAttribute("placeholder", labelVal);
            if (wrapperEmail.classList.contains("is--invalid")) {
                wrapperEmail.classList.remove("is--invalid");
                wrapperEmail.querySelector(".form__input--error").remove();
            }
        } else {
            email.setAttribute("required", "required");
            let labelVal = label.innerHTML + "*"
            label.innerHTML = labelVal;
            email.setAttribute("placeholder", labelVal);
        }
    })
}

if (document.querySelector('[id*="no-email"]')) {
    let noemail = document.querySelector('[id*="no-email"]');
    noEmail(noemail);
}

if (document.getElementById("addNewMemberBtn")) {
    let btnAdd = document.getElementById("addNewMemberBtn");
    let titleAccordion = document.querySelector(".register__h").innerText;
    let copyPanelClone = (document.querySelector(".register__accordion")).cloneNode(true);
    let infoAriaAddDeleteMember = document.getElementById("ariaInfo");


    let counter = 1;
    btnAdd.addEventListener("click", function () {
        counter++;
        let copyPanel = copyPanelClone.cloneNode(true);
        let inputsCopy = copyPanel.querySelectorAll("input, textarea");
        let inputsCopyText = copyPanel.querySelectorAll('input:not([type="checkbox"],[type="radio"]), textarea');
        let inputsCopyCheckbox = copyPanel.querySelectorAll("input[type='checkbox'], input[type='radio'] ");
        let labelsCopy = copyPanel.querySelectorAll("label");
        let title = copyPanel.querySelector(".register__h");
        let legendNr = copyPanel.querySelectorAll("legend .r__nr");
        title.innerHTML = titleAccordion + `: ${counter}`;


        let copyPanelAccordion = copyPanel.querySelector(".accordion__content");
        let copyBtnAccordion = copyPanel.querySelector(".accordion__btn");

        copyPanelAccordion.style.maxHeight = "initial";
        copyPanelAccordion.classList.add("active");
        copyPanelAccordion.setAttribute("aria-hidden", "false");
        copyBtnAccordion.classList.add("active");
        copyBtnAccordion.setAttribute("aria-expanded", "true");

        accordion(copyPanel);

        for (let k = 0; k < legendNr.length; k++) {
            legendNr[k].innerHTML = `${counter} `;
        }
        for (let k = 0; k < inputsCopy.length; k++) {
            let id = inputsCopy[k].getAttribute("id") + "-" + counter;
            inputsCopy[k].setAttribute("id", id);
        }
        for (let k = 0; k < inputsCopyText.length; k++) {
            inputsCopyText[k].value = "";
        }
        for (let j = 0; j < labelsCopy.length; j++) {
            let id = labelsCopy[j].getAttribute("for") + "-" + counter;
            labelsCopy[j].setAttribute("for", id);
        }


        String.prototype.replaceAt = function (index, replacement) {
            return this.substring(0, index) + replacement + this.substring(index + replacement.length);
        }

        function changeNameNr(item, nr) {
            let oldName = item.getAttribute("name");
            let indexOf = oldName.indexOf("[") + 1;
            let newName = oldName.substring(0, indexOf);
            newName += nr + "][]";
            item.setAttribute("name", newName);
        }

        for (let j = 0; j < inputsCopyCheckbox.length; j++) {
            changeNameNr(inputsCopyCheckbox[j], counter - 1);
        }

        if (copyPanel.querySelector(".input--data")) {
            let inputDate = copyPanel.querySelectorAll(".input--data");
            for (let i = 0; i < inputDate.length; i++) {
                maskInputDate(inputDate[i]);
            }
        }

        // if (copyPanel.querySelector(".input--postcode")) {
        //     let inputDate = copyPanel.querySelectorAll(".input--postcode");
        //     for (let i = 0; i < inputDate.length; i++) {
        //         maskInputPostCode(inputDate[i]);
        //     }
        // }
        if (copyPanel.querySelector(".facultative-trips")) {

            let inputFacultative = copyPanel.querySelectorAll(".facultative-trips input");
            for (let i = 0; i < inputFacultative.length; i++) {

                inputFacultative[i].addEventListener("change", countPrice);
            }
        }

        let noemail = copyPanel.querySelector('[id*="no-email"]');
        noEmail(noemail);

        function removeMember(btn) {

            btn.addEventListener("click", function (e) {
                let panel = btn.closest(".register__accordion");
                let namePerson = panel.querySelector("[id*='imie']").value + " " + panel.querySelector("[id*='nazwisko']").value;
                infoAriaAddDeleteMember.innerHTML = `Usunięto uczestnika ${namePerson}`;
                infoAriaAddDeleteMember.className = "alert alert-danger";
                counter--;

                // e.preventDefault();
                panel.remove();
                let allTitles = document.querySelectorAll(".register__h");
                let allBoxes = document.querySelectorAll(".register__accordion");

                let nr = 1;
                for (let i = 0; i < allTitles.length; i++) {
                    if (i > 0) {
                        nr++;
                        allTitles[i].innerText = titleAccordion + `: ${nr}`;
                        let legendsNr = allBoxes[i].querySelectorAll("legend .r__nr");
                        for (let j = 0; j < legendsNr.length; j++) {
                            legendsNr[j].innerHTML = `${nr} `;
                        }
                    }
                }
                //
                //
                let nr2 = 0;
                for (let k = 0; k < allBoxes.length; k++) {
                    if (k > 0) {
                        nr2++;
                        let inputsCopyCheckbox2 = allBoxes[k].querySelectorAll("input[type='checkbox'], input[type='radio'] ");
                        for (let j = 0; j < inputsCopyCheckbox2.length; j++) {
                            changeNameNr(inputsCopyCheckbox2[j], nr2);
                        }
                    }
                }
                countPrice();
            })
        }

        for (let i = 0; i < inputsCopyText.length; ++i) {
            inputsCopyText[i].addEventListener("input", function () {
                checkInputValidate(this);
                inputsCopyText[i].addEventListener("focusout", function () {
                    if (!this.classList.contains("focusout")) {
                        this.classList.add("focusout")
                    }
                    checkInputValidate(this);
                });
            });
        }

        let buttonRemove = document.createElement("button");
        buttonRemove.type = "button";
        buttonRemove.classList.add("removeMember");
        buttonRemove.innerText = "Usuń uczestnika";
        copyPanel.querySelector(".register__fieldset:last-of-type").append(buttonRemove);
        removeMember(buttonRemove);


        document.getElementById("newMemberWrapper").appendChild(infoAriaAddDeleteMember);
        document.getElementById("newMemberWrapper").appendChild(copyPanel);
        countPrice();

        // ustawienie focusa
        copyPanel.querySelector("input:first-child").focus();
        infoAriaAddDeleteMember.className = "alert alert-success";
        infoAriaAddDeleteMember.innerHTML = `Dodano uczestnika ${counter}. Uzupełnij dane w formularzu`;

    })

}


if (document.getElementById("zgloszenie-terminy-select")) {
    let select = document.getElementById("zgloszenie-terminy-select");
    let form = document.getElementById("register2__form");
    let act = form.getAttribute("action");

    let selectNow = 0;
    let termNow = 0;

    function terminySelect(data, form) {
        let wrapper = document.getElementById("zgloszenie-terminy-wrapper");
        let select = document.getElementById("zgloszenie-terminy-select").closest(".form__select");
        let selectSelect = document.getElementById("zgloszenie-terminy-select");
        if (data && data != "false") {
            if (select.classList.contains("is--invalid")) {
                select.classList.remove("is--invalid");
            }
            let trips = JSON.parse(data);
            let fieldset = document.createElement("fieldset");
            let divW = document.createElement("div");
            divW.className = "term__label2__wrapper";
            fieldset.className = "register__fieldset border--none pt-0";
            let legend = document.createElement("legend");
            legend.className = "title--4 pt-10";
            legend.innerText = "Wybierz termin";
            fieldset.append(legend);

            function createInputs(idW, txt, kod, cena, cenaWaluta, cena2, c2W = "0", nr = 0, checked = "false") {

                let div = document.createElement("div");
                div.className = "term__label2";
                let input = document.createElement("input");
                input.type = "radio";
                input.name = "termin";
                input.value = idW;
                input.id = 'dTermin' + nr;
                if (checked == "true") {
                    input.setAttribute("checked", "checked");
                }
                let label = document.createElement("label");
                label.innerHTML = txt;
                let cenaKod = document.createElement("div");
                cenaKod.classList.add("term__label2Code");
                cenaKod.innerHTML = "Kod: " + kod;
                let cenaDiv = document.createElement("div");
                cenaDiv.classList.add("term__label2Price");

                if (parseFloat(cena) == 0) {
                    cenaDiv.innerHTML = "wkrótce"
                } else {
                    cenaDiv.innerHTML = changePrice(cena) + " " + cenaWaluta;
                }
                if (c2W != "0") {
                    cenaDiv.innerHTML = changePrice(cena) + " " + cenaWaluta + " + " + changePrice(cena2) + " " + c2W;
                }
                label.setAttribute("for", 'dTermin' + nr);
                div.append(input);
                div.append(label);
                label.append(cenaKod);
                label.append(cenaDiv);
                divW.append(div);
            }

            wrapper.innerHTML = "";
            for (let i = 0; i < trips.length; i++) {
                let waluta2 = trips[i].waluta_cena_dodatkowa;

                if (waluta2 == "") {
                    waluta2 = "0";
                }

                if (i == "0") {
                    createInputs(trips[i].id, trips[i].odDo, trips[i].kod, trips[i].cena, trips[i].waluta_cena, trips[i].cena_dodatkowa, waluta2, i, "true");
                } else {
                    createInputs(trips[i].id, trips[i].odDo, trips[i].kod, trips[i].cena, trips[i].waluta_cena, trips[i].cena_dodatkowa, waluta2, i, "false");
                }
            }
            fieldset.append(divW);
            wrapper.append(fieldset);

        } else {
            let divA = document.createElement("div");
            divA.className = "alert alert-danger";
            divA.innerHTML = `Obecnie nie mamy terminu dla tego wyjazdu.<br>Wybierz inny wyjazd`;
            wrapper.innerHTML = "";
            wrapper.append(divA);

            select.classList.add("is--invalid");
            form.setAttribute("action", act);
        }


        function addParameter() {
            termNow = document.querySelector("[name='termin']:checked").value;
            let act2 = act + "?id=" + selectNow + "&termin=" + termNow;
            form.setAttribute("action", act2);
            window.location.hash = "?id=" + selectNow + "&termin=" + termNow;

            console.log(selectSelect.options[selectSelect.selectedIndex]);
            let img = selectSelect.options[selectSelect.selectedIndex].getAttribute("data-zdjecie");
            let ico = selectSelect.options[selectSelect.selectedIndex].getAttribute("data-ikonka");
            let nameW = selectSelect.options[selectSelect.selectedIndex].innerText;


            document.querySelector(".ro__right .ro__img").setAttribute("src", img);
            document.querySelector(".ro__right .ro__svg").setAttribute("src", ico);
            document.querySelector(".ro__right .ro__t").innerText = nameW;

        }

        if (document.getElementsByName("termin").length > 0) {
            addParameter();
        }

        let inputsTerm = document.getElementsByName("termin");

        for (let i = 0; i < inputsTerm.length; i++) {
            inputsTerm[i].addEventListener("change", function () {
                addParameter();
            });
        }
    }

    function selectChange() {
        let val = select.value;

        let dataForm = new FormData();
        let href = '/a/?a=terminy&wycieczka=' + val;
        selectNow = val;
        makeRequestEl(href, "POST", dataForm, terminySelect, form);
    }

    selectChange();
    select.addEventListener("change", function () {
        selectChange();
    });
    if (select.closest('.form__select').querySelector(".select-items")) {

        let btns = select.closest('.form__select').querySelectorAll(".select-items>div");

        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                selectChange();
            })
        }
    }
}




